import { Component, effect, ChangeDetectionStrategy } from '@angular/core';
import { Client, Club, RegistryEntry } from '@xanadu/model';
import { NodeComponent } from '@xanadu/core';


@Component({
    selector: 'app-client-node',
    templateUrl: './client-node.component.html',
    styleUrls: ['./client-node.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClientNodeComponent extends NodeComponent {
    static current: Client | Club;

    protected get nodeType(): string | undefined {
        return 'client';
    }

    private iconRoot = 'vpn_lock';
    private iconGroup = 'group';
    private iconType = 'lock_person';

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();

            if (model) {
                if (model.node instanceof Club) {
                    if (model.node.parentId) {
                        this.icon = this.iconGroup;
                    } else {
                        this.icon = this.iconRoot;
                    }
                } else if (model.node instanceof Client) {
                    this.icon = this.iconType;
                    const client = model.node as Client;
                    if (client._system) {
                        model.solo.editable = false;
                    }
                }
            }
        });
    }
}
